export function getRateDisplayValue(value) {
    if (value === undefined || value === null) {
        return '';
    }
    if (value > 1 && value < 1.03) {
        return value.toFixed(3);
    }
    else {
        return value.toFixed(2);
    }
}



// WEBPACK FOOTER //
// ./src/rendering-commons/index.js